<template>
  <div>
   <Header_/>
    <div class="wrapper d-flex flex-column min-vh-100 bg-light">
      <br><br>
      <!-- <AppHeader /> -->
      <div class="body flex-grow-1 px-3" >
        <router-view />
      </div>
      <AppFooter />
    </div>
  </div>
</template>
<script>
//import { CContainer } from '@coreui/vue'
import AppFooter from '@/components/AppFooter.vue'
//import AppHeader from '@/components/AppHeader.vue'
import Header_ from '@/components/Header.vue'


export default {
  name: 'SimpleLayout',
  components: {
    AppFooter,
  //  AppHeader,
    Header_,
   // CContainer,

  },
}
</script>
